import { render, staticRenderFns } from "./_TodoActionsList.vue?vue&type=template&id=5a4add1f&scoped=true&"
import script from "./_TodoActionsList.vue?vue&type=script&lang=js&"
export * from "./_TodoActionsList.vue?vue&type=script&lang=js&"
import style0 from "./_TodoActionsList.vue?vue&type=style&index=0&id=5a4add1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4add1f",
  null
  
)

export default component.exports